var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("Base", {
    attrs: {
      "show-back-button": true,
      "minimal-topbar": true,
      title: "Heimdall - Admin Panel",
    },
    scopedSlots: _vm._u([
      {
        key: "main-content",
        fn: function () {
          return [
            _c(
              "v-tabs",
              {
                attrs: { "fixed-tabs": "", dark: "" },
                model: {
                  value: _vm.activeTab,
                  callback: function ($$v) {
                    _vm.activeTab = $$v
                  },
                  expression: "activeTab",
                },
              },
              [
                _c("v-tab", { key: "users" }, [_vm._v(" User Management ")]),
                _c("v-tab", { key: "groups" }, [_vm._v(" Group Management ")]),
                _c("v-tab", { key: "statistics" }, [_vm._v(" Statistics ")]),
              ],
              1
            ),
            _c(
              "v-container",
              [
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      [
                        _c(
                          "v-card",
                          [
                            _c(
                              "v-tabs-items",
                              {
                                model: {
                                  value: _vm.activeTab,
                                  callback: function ($$v) {
                                    _vm.activeTab = $$v
                                  },
                                  expression: "activeTab",
                                },
                              },
                              [
                                _c(
                                  "v-tab-item",
                                  { key: "users" },
                                  [_c("UserManagement")],
                                  1
                                ),
                                _c(
                                  "v-tab-item",
                                  { key: "groups" },
                                  [
                                    _c("GroupManagement", {
                                      attrs: { "admin-panel": true },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "v-tab-item",
                                  { key: "statistics" },
                                  [_c("statistics")],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }